import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/layout"
import Section from '../components/Section/Section';
import SectionImage from '../components/SectionImage/SectionImage';
import SectionContent from '../components/SectionContent/SectionContent';
import ContactSection from '../components/ContactSection/ContactSection';
import SEO from "../components/seo"

import trailerImg from '../images/section_trailer.jpg';
import hygiene from '../images/hygiene_rating.jpg';

const TrailerPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <Helmet>
      <link href="https://fonts.googleapis.com/css?family=Titillium+Web:200,300,400,600,700,900" rel="stylesheet" type="text/css" />
    </Helmet>
    <Section id="trailer" theme="dark">
      <SectionImage imgUrl={trailerImg} imgAlt="Trailer Image" />
      <SectionContent centered>
        <article>
          <h1>Trailer</h1>
          <p>
            Here is our colourful 5 star hygiene rated catering trailer and meat smoker which can cater for anything from small gatherings right through to large music festivals.
            You may have seen us at Boardmasters and other outdoor based events in the south west.
          </p>
          <img src={hygiene} alt="Hygiene-Rating" />
        </article>
      </SectionContent>
    </Section>
    <ContactSection />
  </Layout>
)

export default TrailerPage
